import { Eye, Wrench } from "lucide-react";
import { Button, Empty } from "~/components/ui";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNotImplementedYet } from "~/hooks/use-not-implemented-yet";
import type { UsedSource } from "@noa/api-core";
import type { ReferenceMapValue } from "@noa/api-client";
import { ReferenceDocumentCard } from "./reference-document-card";

interface ReferenceDocumentsListProps {
  documents: UsedSource[];
  referenceMap: Map<string, ReferenceMapValue>;
}

export const ReferenceDocumentsList: FunctionComponent<ReferenceDocumentsListProps> = ({ documents, referenceMap }) => {
  const { t } = useTranslation();
  const showNotImplementedYet = useNotImplementedYet();

  return (
    <div className="flex flex-1 flex-col overflow-auto p-4 pt-1">
      {documents.length === 0 ? (
        <Empty />
      ) : (
        documents.map((document) => (
          <ReferenceDocumentCard
            key={document.unique}
            document={document}
            textReferenceIndex={referenceMap.get(document.unique)?.refNumber ?? 0}
          />
        ))
      )}

      <Button icon={<Eye size={14} />} onClick={() => showNotImplementedYet(<Wrench size={14} />)} className="shrink-0">
        {t("referenceDocs:viewAllDocuments")}
      </Button>
    </div>
  );
};
